import { useEffect, useState } from 'react'

interface Props {
  dueAt: string | null | undefined
}

/// Wave 1 E1.2 — SLA countdown. Green / amber / red ribbons depending on the
/// time remaining vs configured thresholds (15min / 5min / overdue).
export function SLAClock({ dueAt }: Props) {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30_000)
    return () => clearInterval(id)
  }, [])

  if (!dueAt) {
    return <span className="text-xs text-slate-400">—</span>
  }

  const due = new Date(dueAt).getTime()
  const diffMs = due - now
  const overdue = diffMs < 0
  const diffMin = Math.round(Math.abs(diffMs) / 60_000)

  const color = overdue
    ? 'bg-red-100 text-red-700 border-red-200'
    : diffMin <= 5
      ? 'bg-red-50 text-red-600 border-red-200'
      : diffMin <= 15
        ? 'bg-amber-50 text-amber-700 border-amber-200'
        : 'bg-emerald-50 text-emerald-700 border-emerald-200'

  const label = overdue ? `+${formatDuration(diffMin)}` : `-${formatDuration(diffMin)}`

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium border ${color}`}>
      {overdue ? '⚠' : '⏱'}{label}
    </span>
  )
}

function formatDuration(min: number): string {
  if (min < 60) return `${min}m`
  const h = Math.floor(min / 60)
  const m = min % 60
  return m === 0 ? `${h}h` : `${h}h${m}m`
}
